import React from "react";
import cn from "classnames";
import styles from "./RefundRequests.module.sass";
import Card from "../Card";
import Icon from "../Icon";

const createAnniversaryMessage = (firstName, lastName) => [
  {
    content:
      `Joyeux anniversaire ${firstName} ${lastName} ! 🎉 Toute l\'équipe vous souhaite une excellente journée remplie de bonheur et de réussite ! <span role="img" aria-label="birthday">🎂</span>`,
    icon: "confetti",
    fill: "#FF6A55",
    color: "#FFE7E4",
  },
];

const Anniversary = ({ className, title, classTitle, firstName = "Utilisateur", lastName = "" }) => {
  const anniversaryMessages = createAnniversaryMessage(firstName, lastName);
  
  return (
    <>
      <Card
        className={cn(styles.card, className)}
        title={title}
        classTitle={classTitle}
      >
        <div className={styles.section}>
          <div className={styles.list}>
            {anniversaryMessages.map((message, index) => (
              <div className={styles.item} key={index}>
                <div className={cn(styles.icon, styles.confettiIcon)} style={{ backgroundColor: message.color }}>
                  <div className={styles.confettiContainer}>
                    <span className={styles.confetti}>🎉</span>
                  </div>
                </div>
                <div
                  className={styles.content}
                  dangerouslySetInnerHTML={{ __html: message.content }}
                ></div>
              </div>
            ))}
          </div>
        </div>
      </Card>
    </>
  );
};

export default Anniversary;
